import { useCallback } from 'react'

import { RankingUser } from '@/shared/types/user'

import { shouldSendOnce, sample } from './shouldSendOnce'
import { useAnalytics } from './useAnalytics'

export function useRankingAnalytics() {
  const { track } = useAnalytics()

  const trackRankingViewed = useCallback(
    (rankingType: 'global' | 'school' | 'friends') => {
      if (shouldSendOnce(`ranking_viewed`, `ranking`, 30 * 60 * 1000)) {
        track.event('ranking_viewed', {
          ranking_type: rankingType,
          view_type: 'list',
          context_route: window.location.pathname
        })
      }
    },
    [track]
  )

  const trackUserRankClicked = useCallback(
    (rankingUser: RankingUser) => {
      if (sample(0.2)) {
        track.event('ranking_user_clicked', {
          clicked_user_uid: rankingUser.user.uid,
          clicked_user_name: rankingUser.user.name.slice(0, 50),
          clicked_user_rank: rankingUser.position,
          clicked_user_points: rankingUser.points,
          clicked_user_coins: rankingUser.coins,
          is_current_user: rankingUser.is_current_user,
          context_route: window.location.pathname
        })
      }
    },
    [track]
  )

  return {
    trackRankingViewed,
    trackUserRankClicked
  }
}
